import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	FONT_WT_LIGHT,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	DESKTOP_M_BP,
	TABLET_BP,
	TABLET_M_BP,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const ReviewsWrapper = styled.div`
	padding: 60px 0;
	padding-top: 120px;
	display: flex;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 30px;
		padding-top: 120px;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 30px 10px;
		padding-top: 70px;
		flex-direction: column;
	}
`;

export const TextContainer = styled.div`
	margin: auto 20px auto 75px;
	width: 100%;
	flex-basis: 30%;
	flex-grow: 0;
	flex-shrink: 0;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin: auto 20px auto 0px;
		width: 90%;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		width: 100%;
		text-align: center;
		margin: 30px 0px;
	}
`;

export const ReviewsContainer = styled.div`
	@media only screen and (min-width: ${DESKTOP_SM_BP}px) {
		> div:nth-of-type(2) {
			position: relative;
			left: 10%;
		}
	}
`;

export const CtaWrapper = styled.div`
	padding: 20px 0px;
	@media only screen and (max-width: ${DESKTOP_M_BP}px) and (min-width: ${TABLET_BP}px) {
		button {
			padding: 0px 15px;
		}
	}
`;

export const Heading = styled.div`
	font-size: 36px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_WHITE};
	margin-bottom: 16px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		font-size: 30px;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		font-size: 28px;
		margin-bottom: 15px;
	}
`;

export const SubHeading = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.5;
	color: ${COLOR_WHITE};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-bottom: 25px;
	}
`;
